"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendoScript = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var config_1 = __importDefault(require("next/config"));
var PendoScript = function () {
    var publicRuntimeConfig = (0, config_1.default)().publicRuntimeConfig;
    if (!publicRuntimeConfig.PENDO_API_KEY) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
    return ((0, jsx_runtime_1.jsx)("script", { defer: true, dangerouslySetInnerHTML: {
            __html: "\n        (function(apiKey){\n          (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];\n          v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){\n              o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);\n              y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';\n              z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');\n      })('".concat(publicRuntimeConfig.PENDO_API_KEY, "');\n    "),
        } }));
};
exports.PendoScript = PendoScript;
exports.default = exports.PendoScript;
